class UrlUtil {
    constructor(){}

    // pathname에서 ccUrl 추출
    getCcUrl() {
        if (window.location.pathname.startsWith('/home/')) { // pathname 형식이 정상적인지 확인
            return window.location.pathname.split('/')[2]; // pathname(/home/{ccUrl} 형식)에서 ccUrl 추출
        }
        return null;
    }

    // window.location에서 protocol과 domain 추출
    getProtocolAndDomain() {
        return window.location.protocol + '//' + window.location.host;
    }
}

export default UrlUtil;